import React from 'react';
import EventRegistrationsAdmin from '@/pages/admin/EventRegistrationsAdmin';

const DEMO_EVENT_ID = 'f83c2769-b4aa-4ba9-9e3e-5e205fd40047';

const DemoRegistrations: React.FC = () => {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Registrations Demo</h1>
        <p className="text-gray-600">View and manage event registrations</p>
      </div>
      <EventRegistrationsAdmin />
    </div>
  );
};

export default DemoRegistrations;
